import { IOrderHistoryQuery } from "../../models/order/order-history/query";
import { IOrderHistory } from "../../models/order/order-history/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, OrderHistoryLoading } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: { loading: OrderHistoryLoading | OrderHistoryLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IOrderHistory> } }
  | QueryAction<IOrderHistoryQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }
    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
